<template>
    <div class="mb-2">
        <input type="button" @click="adicionarEstilo" class="btn btn-success" value="Criar">
    </div>
</template>
<script>

export default {

    data: function () {
        return {
            VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
            loading: false,
            thumb: {
                id_vsl: 221,
                tumb_start: "/",
                tumb_pause: "/",
                tumb_end: "/",
                tumb_ativo: 0,
                tumb_key_name: "/"
            },
            errorMessage: null,

        }
    },

    methods: {
        adicionarEstilo() {
          
            fetch(`http://${this.VUE_APP_HOST_API_BACKEND}/tumb`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: '{"id_vsl":"' + this.thumb.id_vsl +
                    '","tumb_start":"' + this.thumb.tumb_start +
                    '","tumb_pause":"' + this.thumb.tumb_pause +
                    '","tumb_end":"' + this.thumb.tumb_end +
                    '","tumb_ativo":"' + this.thumb.tumb_ativo +
                    '","tumb_key_name":"' + this.thumb.tumb_key_name +

                    '"}'
            })

                .then(response => {
                    this.$alert(" adicionada com sucesso.")
                    return this.$router.push('');

                })
                .catch(err => console.error(err));
        },

    }
}


</script>
